<template>
  <div class="input-radio-group">
    <InputRadio
      v-for="option of options"
      :id="option.id"
      :key="option.id"
      class="input-radio-group__item"
      :name="name"
      :checked="getChecked(option)"
    >
      {{ option.title }}
    </InputRadio>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import InputRadio from '@/components/InputRadio/InputRadio.vue';

  export default defineNuxtComponent({
    name: 'InputRadioGroup',

    components: {
      InputRadio,
    },

    props: {
      name: {
        type: String as PropType<string>,
        required: true,
      },

      options: {
        type: Array as PropType<Array<any>>,
        required: true,
      },

      value: {
        required: true,
        validator: (value: any) => {
          return typeof value === 'string' || value === null;
        },
      },
    },

    computed: {},

    methods: {
      getChecked(option: any) {
        return option.id === this.value;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .input-radio-group {
    display: flex;

    &__item {
      & + & {
        margin-left: 32px;
      }
    }
  }
</style>
